/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class PaymentControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paymentControllerStripeCreateCheckoutSession
   */
  static readonly PaymentControllerStripeCreateCheckoutSessionPath = '/payment/stripe/action/create-checkout-session';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stripeCreateCheckoutSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stripeCreateCheckoutSession$Response(params: {
    body: { 'productId': string, 'priceId': string }
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentControllerService.PaymentControllerStripeCreateCheckoutSessionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stripeCreateCheckoutSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stripeCreateCheckoutSession(params: {
    body: { 'productId': string, 'priceId': string }
  }): Observable<void> {

    return this.stripeCreateCheckoutSession$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentControllerStripeInvoicePaymentSucceededWebhook
   */
  static readonly PaymentControllerStripeInvoicePaymentSucceededWebhookPath = '/payment/stripe/webhook/invoice-payment-succeeded';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stripeInvoicePaymentSucceededWebhook()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stripeInvoicePaymentSucceededWebhook$Response(params: {
    body: {  }
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentControllerService.PaymentControllerStripeInvoicePaymentSucceededWebhookPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stripeInvoicePaymentSucceededWebhook$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stripeInvoicePaymentSucceededWebhook(params: {
    body: {  }
  }): Observable<void> {

    return this.stripeInvoicePaymentSucceededWebhook$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
